export default "__VITE_ASSET__C6bj1H_s__"